function n(e, o) {
  if (!e)
    return;
  const d = document.createElement("a");
  d.href = e, o !== void 0 && (d.download = o), document.body.appendChild(d), d.click(), document.body.removeChild(d);
}
export {
  n as download
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/dom/download.js
// module id = 456
// module chunks = 41